/* flow */
import React, { PureComponent } from 'react'
import Tooltip from 'antd/lib/tooltip'
import {decimalCount, twoDec} from './utils'
import { changeColor } from './globals'
import labels from './labels'
import type {Lang, Mode} from './App'
import type { Node } from 'react'

type NumberProps = {
  num: number,
  percent?: boolean,
  className?: string
}

export class NumberCell extends PureComponent<NumberProps> {
  render () {
    const { num, percent = false, className } = this.props
    const n = num === null ? 0 : twoDec(num)
    return (
      <td
        className={`${className} ${percent ? changeColor(n) : ''} right aligned`}>
        {num === null ? '-' : (percent ? `${n}%` : n)}
      </td>
    )
  }
}

export class FundValueCell extends PureComponent<NumberProps> {
  render () {
    const { num, className, lang } = this.props
    const n = num === null ? 0 : twoDec(num)
    const isDecimalCountMoreThan2 = num === null ? false : decimalCount(num) > 2
    const popup = labels[lang].fundValueToolTipPart1 + num + labels[lang].fundValueToolTipPart2
    return (
        isDecimalCountMoreThan2
        ? <Tooltip title={popup}>
            <td className={`${className} right aligned`}>
              {num === null ? '-' : n + '*'}
            </td>
          </Tooltip>
        : <td className={`${className} right aligned`}>
              {num === null ? '-' : n}
          </td>
    )
  }
}

type CustomProps = {
  content: string,
  textAlign?: 'left' | 'center' | 'right',
  uri?: string,
  icon?: boolean,
  popup?: string,
  className?: string
}

export class CustomCell extends PureComponent<CustomProps> {
  render () {
    const { content, textAlign = 'left', uri = '', icon = false, popup = '', className = '' } = this.props
    let con: Node = content
    if (icon && uri) {
      con = <a href={uri} target='_blank'><i className={`${content} icon`}></i></a>
    } else if (icon) {
      con = <i className={`${content} icon`}></i>
    } else if (uri) {
      con = <a href={uri} target='_blank'>{content}</a>
    }
    
    return (
      popup
      ? <Tooltip title={popup}>
          <td className={`${className} ${textAlign} aligned`}>
            {con}
        </td>
      </Tooltip>
      : <td 
        className={`${className} ${textAlign} aligned`}>
        {con}
      </td>
    )
  }
}

type CheckboxProps = {
  name: string,
  checked: boolean,
  disabled: boolean,
  lang: Lang,
  onChange: (e: SyntheticEvent<HTMLInputElement>) => void
}

export class CheckboxCell extends PureComponent<CheckboxProps> {
  render () {
    const { name, onChange, checked, disabled, lang } = this.props
    const content = labels[lang][(checked && 'unselectMsg') || (disabled && 'selectMsgLimit') || 'selectMsg' ]
    return (
      <Tooltip title={content}>
        <td
          className="collapsing center aligned">
          <label className='control'>
            <input
              type='checkbox'
              disabled={disabled}
              name={name}
              onChange={onChange}
              checked={checked}
            />
            <div className='control__indicator'></div>
          </label> 
        </td>
      </Tooltip>
    )
  }
}

type RiskProps = {
  num: 1 | 2 | 3 | 4 | 5 | 6 | 7,
  lang: Lang,
  className?: string,
  mode: Mode
}

export const risk = {
  0: { percent: 0, color: 'goblin' },
  1: { percent: 14.3, color: 'goblin' },
  2: { percent: 28.6, color: 'apple' },
  3: { percent: 42.9, color: 'celadon' },
  4: { percent: 57.1, color: 'creambrulee' },
  5: { percent: 71.43, color: 'yellow'},
  6: { percent: 85.71, color: 'golddrop' },
  7: { percent: 100, color: 'mojo' }
}

export class RiskCell extends PureComponent<RiskProps> {

  renderContent() {
    const { num, className } = this.props
    const { percent, color } = risk[num]
    return (
        <td
            className={`${className} center aligned middle aligned`}>
          <div
              className={`ui progress ac-risk-progress ac-risk-color-${color}`}
              data-percent={percent}>
            <div className="bar" style={{ width: `${percent}%` }}></div>
          </div>
        </td>
    );
  }

  render () {
    const { num, lang, mode } = this.props
    const { percent } = risk[num]
    return (
        (percent !== 0 && (
            <Tooltip title={labels[lang][mode + 'RiskLevel' + num]}>
              {this.renderContent()}
            </Tooltip>
        )) || this.renderContent()
    )
  }
}



// WEBPACK FOOTER //
// ./src/ListCells.js